import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e5f3b310"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "headline" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("股息及股息率")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("股息/净利润")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("股息增长率")
const _hoisted_6 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InfoCircleOutlined = _resolveComponent("InfoCircleOutlined")!
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_Charts = _resolveComponent("Charts")!
  const _component_Nodata = _resolveComponent("Nodata")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createBlock(_component_a_spin, {
    tip: "加载中...",
    spinning: _ctx.spinning
  }, {
    default: _withCtx(() => [
      ((_ctx.data || []).length)
        ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_a_popover, {
                content: "股息率\n股息率是股息与股价之间的比率，是衡量企业是否具有价值投资及回报股东的重要标尺。\n图表中，年度股息率=每年每股股息/财年最后一个交易日的收盘价x100%",
                trigger: "hover",
                overlayClassName: "tooltipstyle",
                arrowPointAtCenter: "",
                placement: "topLeft"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_InfoCircleOutlined, { style: {"margin-left":"6px"} })
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_a_radio_group, {
              value: _ctx.currentTab,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentTab) = $event)),
              "button-style": "solid",
              onChange: _ctx.changeTab
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_button, { value: "dividendAndYield" }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_radio_button, { value: "dividendNetIncome" }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_radio_button, { value: "dividendRate" }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value", "onChange"]),
            _createVNode(_component_Charts, {
              id: "dividendChartlhlgxxg",
              option: _ctx.option,
              style: {"height":"450px"}
            }, null, 8, ["option"])
          ]))
        : (_openBlock(), _createElementBlock("section", _hoisted_6, [
            _createVNode(_component_Nodata, {
              nodatadesc: _ctx.itemdata.title
            }, null, 8, ["nodatadesc"])
          ]))
    ]),
    _: 1
  }, 8, ["spinning"]))
}